module.exports = __webpack_public_path__ + "img/2-2.707259ab.svg";